// extracted by mini-css-extract-plugin
export var filterIncDec = "_cr-0";
export var leftBorder = "_cr-1";
export var rightBorder = "_cr-2";
export var stringInput = "_cr-3";